import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { FIREBASE_CONFIG } from 'src/app/environment';
import { initializeApp, getApps } from 'firebase/app';

// Ensure we reuse the existing app instance if already initialized
const app =
  getApps().length > 0 ? getApps()[0] : initializeApp(FIREBASE_CONFIG);
const storageBucket = FIREBASE_CONFIG.storageBucket;
const storage = storageBucket
  ? getStorage(app, storageBucket)
  : getStorage(app);

function buildPath(prefix: string, file: File, locationKey?: string): string {
  const ext = (file.name.split('.').pop() || 'bin').toLowerCase();
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const dir = (locationKey || 'global').trim() || 'global';
  return `${prefix}/${dir}/${id}.${ext}`;
}

async function uploadFileToStorage(path: string, file: File): Promise<string> {
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file, {
    contentType: file.type || 'application/octet-stream',
  });
  return getDownloadURL(fileRef);
}

export async function uploadCampaignMedia(
  file: File,
  locationKey?: string,
): Promise<string> {
  const path = buildPath('campaign-media', file, locationKey);
  return uploadFileToStorage(path, file);
}

export async function uploadSettingsLogo(
  file: File,
  locationKey?: string,
): Promise<string> {
  const path = buildPath('settings-branding', file, locationKey);
  return uploadFileToStorage(path, file);
}
